import { useState, useEffect } from 'react';
import Slider from "react-slick";
import { useNavigate } from 'react-router-dom';
import { SampleNextArrow, SamplePrevArrow } from "./SliderSampleArrows";
import BookContainer from "../../../components/common/BookContainer";
import { useTranslation } from 'react-i18next';

export default function BooksSlider() {
    const navigate = useNavigate();
    const [libraryBooks, setLibraryBooks] = useState([]);
    const [error, setError] = useState(null);
    const { t, i18n } = useTranslation();

    const formatTitleForUrl = (title) => {
        return title
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^\u0600-\u06FF\w-]/g, ''); // Keep Arabic, English, numbers, and hyphens
    };

    const handleBookClick = (bookId) => {
        async function fetchLibrary() {
            try {
                const book = await fetch(`${process.env.REACT_APP_MASAR_API_URL}/library/books/${bookId}`, {
                    method: "GET",
                    headers: {
                        "accept": "*/*"
                    },
                    body: JSON.stringify()
                });
                const bookByID = await book.json();
                navigate(`/${i18n.language}/masarLibrary/${bookByID?.data?.id}/${formatTitleForUrl(bookByID?.data?.title)}`)
            } catch (err) {
                setError(t("errorGetBook"));
            }
        }
        fetchLibrary();
    };

    const settings = {
        className: "center",
        centerPadding: "60px",
        dots: true,
        infinite: true,
        speed: 4000,
        autoplay: true,
        slidesToShow: 5,
        slidesToScroll: 3,
        initialSlide: 0,
        swipeToSlide: true,
        pauseOnHover: true,
        autoplaySpeed: 6000,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    infinite: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    nextArrow: null,
                    prevArrow: null,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                }
            }
        ]
    };

    useEffect(() => {
        async function fetchLibrary() {
            try {
                const booksData = await fetch(`${process.env.REACT_APP_MASAR_API_URL}/library/books?limit=50`, {
                    method: "GET",
                    headers: {
                        "accept": "*/*"
                    },
                    body: JSON.stringify()
                });
                const responseData = await booksData.json();
                setLibraryBooks(responseData);
            } catch (err) {
                setError(t("errorGetData"));
            }
        }
        fetchLibrary();
    }, [t]);

    return (
        <div className="slider-container container text-center">
            <Slider {...settings}>
                {/* .filter(book => book.category?.type !== 'Children') */}
                {libraryBooks?.data?.result
                    .slice(0, 10)
                    .map((item, index) => (
                        <BookContainer
                            handleBookClick={handleBookClick}
                            item={item}
                            index={index} />
                    ))}
            </Slider>
            {error && <p className="text-center text-warning">{error}</p>}
        </div>
    );
}